<template>
  <layout-main-inner title="编辑企业">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="info"
      :rules="rules"
      label-width="120px"
    >
      <layout-card-wrap hasSlot>
        <template slot="title">基本信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="企业名称："
              prop="vendorName">
              <el-input v-model="info.vendorName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="信用代码："
              prop="unifiedCreditCode">
              <el-input v-model="info.unifiedCreditCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="地址："
              prop="vendorAddress">
              <el-input v-model="info.vendorAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="联系人："
              prop="vendorPerson">
              <el-input v-model="info.vendorPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="手机号："
              prop="vendorMobile">
              <el-input v-model="info.vendorMobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="E-mail："
              prop="vendorEmail">
              <el-input v-model="info.vendorEmail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="企业账号："
              prop="adminAccount">
              <span v-if="$route.query.vendorId"> {{ info.adminAccount }}</span>
              <el-input
                v-else
                v-model="info.adminAccount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="机构："
              prop="seaportId">
              <seaport-select v-model="info.seaportId" />
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap hasSlot>
        <template slot="title">
          <span>品类信息</span>
          <el-button
            type="primary"
            @click="selectCate">
            选择
          </el-button>
        </template>
        <el-form-item
          label=""
          label-width="0"
          prop="quarantines">
          <el-table
            border=""
            :data="info.quarantines">
            <el-table-column
              label="分类名称"
              prop="quarantineName">
            </el-table-column>
            <el-table-column
              label="分类编码"
              width="130"
              prop="quarantineCode">
            </el-table-column>
            <el-table-column width="100">
              <template slot-scope="{ row, $index }">
                <el-button
                  type="danger"
                  @click="deleteitem(row, $index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <button-back />
      <el-button
        type="primary"
        @click="submitForm">保存</el-button>
    </template>
    <select-modal
      ref="select"
      :callback="callback"> </select-modal>
  </layout-main-inner>
</template>
<script>
import SelectModal from './selectModal'
import SeaportSelect from '../../commonComp/seaportSelect.vue'
export default {
  name: 'VendorEdit',
  components: { SelectModal, SeaportSelect },
  data() {
    return {
      loading: false,
      info: {
        vendorName: '',
        unifiedCreditCode: '',
        vendorAddress: '',
        vendorPerson: '',
        vendorMobile: '',
        vendorEmail: '',
        adminAccount: '',
        seaportId: null,
        quarantines: []
      },
      rules: {
        vendorName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        unifiedCreditCode: [
          { required: true, message: '请输入信用代码', trigger: 'change' },
          {
            pattern: /^[0-9a-zA-Z]{5,20}$/,
            message: '请输入正确的信用代码',
            trigger: 'blur'
          }
        ],
        vendorPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        vendorMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        vendorEmail: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        vendorAddress: [
          { required: true, message: '请输入企业地址', trigger: 'blur' },
          { max: 30, message: '长度最多 50 个字符', trigger: 'blur' }
        ],
        adminAccount: [
          { required: true, message: '请输企业账号', trigger: 'blur' },
          {
            pattern: /^[0-9a-zA-Z]{3,20}$/,
            message: '请输入长度3-20位的企业账号(数字+字母)',
            trigger: 'blur'
          }
        ],
        seaportId: [
          { required: true, message: '请选择机构', trigger: 'change' }
        ],
        quarantines: [
          { required: true, message: '请选择品类', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    if (this.$route.query.vendorId) {
      this.getvendor()
    }
  },
  methods: {
    selectCate() {
      this.$refs.select.init(this.info.quarantines)
    },
    callback(list) {
      this.$set(this.info, 'quarantines', list)
    },
    deleteitem(row, $index) {
      console.log(row)
      this.info.quarantines.splice($index, 1)
    },
    getvendor() {
      this.loading = true
      this.$store.dispatch('account/getvendor', {
        payload: this.$route.query,
        success: (res) => {
          this.loading = false
          this.info = {
            ...res.data,
            quarantines: res.data.quarantines || []
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.$route.query.vendorId
            ? 'updatevendor'
            : 'addvendor'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
